<template>
  <div id="main">
    <RouterView />
  </div>
</template>

<style scoped>
* {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#main {
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
